import React from 'react'
import styles from './IconVideoPlayer.module.scss'

export default function IconVideoPlayer() {
    return <div className={styles.root} />
}
